export default __webpack_public_path__ + "static/media/case.042c4e6c.md";